<template>
  <div :class="isMobile==0?'':'brand-story_mobile'" class="brand-story">
    <div class="brand_story_container" :class="isMobile==0?'brand_story_container':'brand_story_container_mobile'">
      <!-- 标题 -->
      <div :class="isMobile==0?'':'brand_story_title_mobile'" class="brand_story_title animate-fade-in" v-if="lang.fyType == 2" >BRAND STORY</div>
      <div class="brand_story_title animate-fade-in" v-else>品牌故事</div>

      <!-- 图片 -->
      <img v-if="isMobile==0" class="brand_story_img animate-fade-in" src="../assets/qy2.jpg" alt="">
      <img v-if="isMobile==1" style="margin-bottom: 20px;" class="brand_story_img_mobile animate-fade-in" src="../assets/qy2.jpg" alt="">




      <!-- 文本内容 -->
      <div v-if="lang.fyType == 2" class="brand_content animate-fade-in">
        Chapter 1:  As the dawn of the new millennium was about to illuminate the world in 1999, our story began in China. Driven by a relentless pursuit of exquisite craftsmanship and extraordinary materials, we rooted ourselves in the furniture manufacturing industry.
Exceptional products start with extraordinary materials. Nevertheless, we were determined to push further boundaries. Through innovative technologies, we have endowed stainless steel with vibrant artistic colors. We have introduced Haitan Wood—hailed as the "treasure among woods"—and crafted it into durable as well as weather-resistant furniture that enhance users’ outdoor experience.
Over eight years of accumulation and refinement, we are not just manufacturing furniture, but also creating a lifestyle—one that integrates natural textures, modern aesthetics, and durability for a quality life. Every single product represents our interpretation of and tribute to "home".
      </div>
      <div v-else class="brand_content animate-fade-in">
        第一章：匠心的根基
1999年，当新千年的曙光即将照亮世界之际，我们的故事在中国悄然启幕。怀揣着对精湛工艺与非凡材质的执着追求，我们扎根于家具制造行业。
卓越的产品始于非凡的材质。然而，我们并未止步于此。通过创新的技术，我们让冷峻的不锈钢焕发出缤纷的艺术色彩；引进堪称“木中瑰宝”的海檀木，将其打造为能够历经风雨、陪伴用户享受户外时光的耐久家具。
这八年，是沉淀与锤炼的八年。我们不仅在制造家具，更是在雕琢一种生活方式——一种融合了自然质感、现代美学与坚固耐用的品质生活。每一件产品，都是我们对“家”的理解与致敬。
      </div>

      <img v-if="isMobile==0" class="brand_story_img animate-fade-in" src="../assets/qy3.jpg" alt="">
      <img v-if="isMobile==1" style="margin-bottom: 20px;margin-top: 20px;" class="brand_story_img_mobile animate-fade-in" src="../assets/qy3.jpg" alt="">

      <div v-if="lang.fyType == 2" class="brand_content animate-fade-in">
        Chapter 2: Vision Across Land and Sea
The profound understanding of material characteristics, accurate mastery of ergonomics and insistent pursuit of aesthetics—all accumulated from our experience in furniture manufacturing industry—have become the foundation for us to step into a broader horizon. In 2007, a daring concept emerged: to extend our "home-crafting" philosophy to the ocean.

We stepped into the yacht manufacturing industry. This was more than an industry leap. It was the launch of a dream.

We gathered global wisdom and teamed up with top yacht designers from the UK. We integrated their leading design concepts and profound understanding of maritime culture with our superior manufacturing craftsmanship and expertise from Taiwan.
      </div>
      <div v-else class="brand_content animate-fade-in">
        第二章：跨越陆海的视野
深耕家具领域所积累的对材料性能的深刻理解、对人体工学的精准把握，以及对美学的不懈追求，成为了我们迈向更广阔天地的基石。2007年，一个大胆的构想在我们心中澎湃——将我们对“家”的营造理念，延伸至浩瀚的海洋。
我们毅然进入了游艇制造领域。这不仅是一次行业的跨越，更是一次梦想的启航。
我们汇聚全球智慧，携手英国顶尖的游艇设计师，将他们前瞻性的设计理念与对海洋文化的深刻理解，同我们引以为傲的台湾精湛制造工艺与人才技术相融合。
      </div>


      <img v-if="isMobile==0" class="brand_story_img animate-fade-in" src="../assets/bt.jpg" alt="">
      <img v-if="isMobile==1" style="margin-bottom: 20px;margin-top: 20px;" class="brand_story_img_mobile animate-fade-in" src="../assets/bt.jpg" alt="">

      <div v-if="lang.fyType == 2" class="brand_content animate-fade-in">
        Chapter 3: The Eternal Pursuit of Craftsmanship
From land to sea, from living room to yacht deck, although the scenario changes, our original aspiration — reverence for extraordinary materials, exploration of innovative craftsmanship and dedication to flawless quality — remains unwavering. 

Our brand story is a harmonious sonata of "crossover" and "dedication". Decades of profound experience in furniture manufacturing has deepen our understanding of integrating comfort, durability and aesthetics. The grand vision of yacht manufacturing creates a broader stage for our skills and craftsmanship.

Today, we are not only the creators of high-quality home life, but also the pioneers of luxurious marine life. What we offer is more than just a piece of furniture or a yacht. By transcending boundaries, it is a relentless pursuit of the ultimate lifestyle.
Whether you are enjoying cozy moments at home or chasing the wind on the sea, our craftsmanship will always be with you.
This is our journey—an extraordinary story about the eternal pursuit that is still being written.

      </div>
      <div v-else class="brand_content animate-fade-in">
        第三章：同一份匠心的永恒追求
从陆地到海洋，从客厅到甲板，变化的只是场景，不变的，是我们恪守至今的初心——对顶级材质的敬畏，对创新工艺的探索，以及对完美品质的偏执。
我们的品牌故事，是一段关于“跨界”与“专注”的和谐奏鸣曲。是家具制造的深厚根基，让我们深刻理解舒适、耐用与美学的融合之道；是游艇制造的宏大梦想，让我们的技艺与匠心拥有了更广阔的舞台。
今天，我们既是高品质家居生活的缔造者，也是奢华海洋生活的引航者。我们提供的不仅仅是一件家具或一艘游艇，更是一种跨越边界、追求极致的生活态度。无论您是在家中享受宁静时光，还是在海上追逐自由之风，我们的匠心，始终相伴。
      </div>
    </div>
    <bottomText style="width: 100%;"></bottomText>
  </div>
</template>

<script>
// 脚本部分保持不变
import bottomText from './bottomText.vue';

export default {
  components: {
    bottomText
  },
  name: 'BrandStory',
  data() {
    return {
      lang: {},

      isMobile:0
    }
  },
  mounted() {
    this.isMobile=localStorage.getItem('isMobile')
    this.lang = JSON.parse(localStorage.getItem('Lang'))
    window.addEventListener('langChange', () => {
      this.syncLangFromStorage();
    });
  },
  watch: {
    lang: {
      handler(newLang, oldLang) {
        console.log('Lang 变化了：', newLang);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    syncLangFromStorage() {
      this.lang = JSON.parse(localStorage.getItem('Lang'))
      console.log('同步本地存储的语言：', this.lang);
    }
  }
}
</script>

<style>
/* 原有样式保持不变 */
.brand-story {
  height:100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.brand-story_mobile{
  height:80%;
}
.brand_story_container {
  display: flex;
  flex-direction: column;
  width: 71%;
  margin: 60px auto;
}
.brand_story_container_mobile{
  display: flex;
  flex-direction: column;
  width: 92%;
  margin: 15px auto;
}
.brand_story_title {
  text-align: left;
  font-family: Arial, sans-serif;
  font-weight: 600;
  font-size: 36px;
  color: #021131;
  line-height: 36px;
}
.brand_story_title_mobile{
  margin-bottom: 10px;
  font-size: 22px;
}
.brand_story_img {
  width: 100%;
  height: 700px;
  border-radius: 0px 0px 0px 0px;
  margin: 40px 0px 20px 0px;
}
.brand_story_img_mobile_mobile {
  width: 92%;
  height: 400px;
  border-radius: 0px 0px 0px 0px;
  margin-bottom: 20px;
}
.brand_content {
  letter-spacing:1px ;
  text-align: left;
  font-family: Arial, sans-serif;
  font-weight: 500;
  font-size: 18px;
  color: #35353d;
  line-height: 25px;
}

.content {
  margin: 20px auto;
  width: 1400px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #021131;
  text-align: left;
}

/* 添加浮现动画相关样式 */
/* 动画关键帧：从透明+下移到不透明+原位 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
    /* 轻微下移，增强浮现感 */
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 动画类：统一应用到需要浮现的元素 */
.animate-fade-in {
  opacity: 0;
  /* 初始透明 */
  animation: fadeIn 0.8s ease-out forwards;
  /* 0.8秒动画，结束后保持最终状态 */
}

/* 给不同元素设置延迟，形成依次浮现效果 */
.brand_story_title {
  animation-delay: 0s;
  /* 标题最先出现 */
}

.brand_story_img {
  animation-delay: 0.3s;
  /* 图片延迟0.3秒 */
}

.brand_content {
  animation-delay: 0.6s;
  /* 文本延迟0.6秒 */
}
</style>